import React from "react";
import withShipment from "../../../withShipment";
import {
    createCompany,
    listCompanies,
    updateCompany,
} from '../../../redux/actions/settings';
import CustomToolbar from "../../global/CustomToolbar";
import {
    BACK_TO_MENU_TITLE,
    DEFAULT_ROWS_PER_PAGE,
    DEFAULT_SORT_BY_HEAD_CELL, CREATE_COMPANY_TITLE, MANAGE_COMPANY_TABLE_HEAD_CELLS, COMPANY_TOOLBAR_TITLE,
} from './constants';
import ManageCompanyForm from "./ManageCompanyForm";
import Paper from "@material-ui/core/Paper";
import {IconButton  } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import EditIcon from "@material-ui/icons/Edit";
import { ASC } from '../../global/constants';
import SearchableTable from "../../global/Search/SearchableTable";
import { userInfoSelector } from "../../../redux/selectors/auth";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";
import {Tooltip} from "@mui/material";
import TablePage from "../../global/Table/TablePage";
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import {clearStatus} from "../../../redux/actions/global";
import {statusSelector} from "../../../redux/selectors/global";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { getRoles } from '../../../redux/actions/userManagement';
import { rolesSelector } from '../../../redux/selectors/userManagement';
import {companySelector} from "../../../redux/selectors/settings";

import "./ManageCompanyTable.css"


class ManageCompanyTable extends SearchableTable {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: DEFAULT_ROWS_PER_PAGE,
            addingCompany: false,
            editingCompany: null,
            order: ASC,
            orderBy: DEFAULT_SORT_BY_HEAD_CELL,
            isSearch: false, // true if search value is not empty, false otherwise
            searchValue: "", // the value in the search field (updates on change)
            searchRows: 0, // number of rows displayed while search criteria is met
            missingError: false, //missing error to print at alert
        }
    }


    componentDidMount() {
        this.props.listCompanies()
        this.props.getRoles({ locationId: this.props.userInfo.selectedLocationId, type: "company" })
    }


    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText){
            this.openFeedbackBar()
        }
    }


    openFeedbackBar = (status,message) => {
        this.setState({feedbackStatus: status, feedbackMessage: message,feedbackBarOpen: true})
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage:''}, () => {
            this.props.clearStatus()
        })
    }

    handleOpenCompany = (row) => {
        this.setState({
            editingCompany: row
        })
    }


    handleClose = () => {
        this.setState({
            addingCompany: false,
        }, () => this.setState({ editingCompany: null }))
    }

    handleSave = (addingCompany, data) => {

            this.setState({ missingError: false })
            let dataToPost = { ...data }
            if (addingCompany) {
                this.props.createCompany(dataToPost,() => window.location.reload())
            }
            else {
              let dataToPost = { ...data, companyId: data.companyId }
                this.props.updateCompany(dataToPost)
                this.setState({
                    addingCompany: false
                }, () => this.setState({ editingCompany: null }))
            }

    }



    getTableHeaders = () => {
        let headers = []
        headers.push(Layout.columnHead(null,null,null))
        MANAGE_COMPANY_TABLE_HEAD_CELLS.forEach((headCell) => {
            headers.push(Layout.columnHead(headCell.label, headCell.id, "center"))
        })
        return headers
    }


    creatingCompany = () => {
        this.setState({
            addingCompany: true
        })
    }

    cancelCompany= () => {
           this.setState({
            addingCompany: false,
            editingCompany: false
        })
    }


    render() {

        let headerButtons = []
        if (!this.state.editingCompany && !this.state.addingCompany) {
                headerButtons = [
                    { icon: <AddCircleIcon />, handler:  this.creatingCompany, title: "Create new company" },
                ]
        }else{
                headerButtons = [
                    { icon: <KeyboardBackspaceIcon />, handler: this.cancelCompany, title: "Back" },
                ]
        }



        return (
            <>
                <Paper className='paper'>
                    <FeedbackBar
                        open={this.state.feedbackBarOpen}
                        handleClose={this.closeFeedbackBar}
                        severity={this.state.feedbackStatus}
                        message={this.state.feedbackMessage}
                    />
                    <ErrorFeedbackBar />
                    <CustomToolbar
                        title={ COMPANY_TOOLBAR_TITLE}
                        createTitle={CREATE_COMPANY_TITLE}
                        backTitle={BACK_TO_MENU_TITLE}
                        onClick={() => { this.setState({ addingCompany: true }) }}
                        handleClose={this.handleClose}
                        headerButtons={headerButtons}
                    />


                    {!this.state.editingCompany ?
                        this.state.addingCompany ?
                            <ManageCompanyForm
                                addingCompany={true}
                                handleClose={this.handleClose}
                                handleSave={this.handleSave}
                                missingError={this.state.missingError}
                                companies={this.props.companies}
                                openFeedbackBar={this.openFeedbackBar}
                                getRoles={this.props.getRoles}
                                allRoles={this.props.roles}
                                listMasterAdminsPerLocation={this.props.listMasterAdminsPerLocation}
                                masterAdminsLocation={this.props.masterAdminsLocation}

                            />
                            :
                            <>
                                <TablePage
                                    tableName="companyTable"
                                    tableRows={this.props.companies}
                                    tableColumnHeads={this.getTableHeaders()}
                                    tableRow={(row, index) => <React.Fragment>
                                        <TableCell style={{textAlign: "center", width: "1%"}}>
                                            <Tooltip title={"Edit company"}>
                                                <IconButton onClick={() => this.handleOpenCompany(row)}>
                                                    <EditIcon
                                                        fontSize='medium'
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell >
                                        <TableCell style={{textAlign: "center"}}>
                                            {row.name}
                                        </TableCell>

                                        <TableCell style={{textAlign: "center"}}>

                                            {row?.status === 'active' ? (
                                                <ToggleOnIcon style={{ color: 'green', fontSize: '36px' }} />
                                            ) : row?.status === 'closed' ? (
                                                <ToggleOffIcon style={{ color: 'red', fontSize: '36px' }} />
                                            ) : row?.status === 'hold' ? (
                                                <ToggleOffIcon style={{ color: 'orange', fontSize: '36px' }} />
                                            ) : null}

                                        </TableCell>
                                    </React.Fragment>}
                                    onRowDoubleClick={(row) => {
                                        this.handleOpenCompany(row)
                                    }}
                                />
                            </>
                        :
                        <ManageCompanyForm
                            addingCompany={false}
                            editingCompany={this.state.editingCompany}
                            handleClose={this.handleClose}
                            handleSave={this.handleSave}
                            companies={this.props.companies}
                            licenseKey={this.props.licenseKey}
                            getLicenseKey={this.props.getLicenseKey}
                            generateLicenseKey={this.props.generateLicenseKey}
                            handleRenewLicenseKey={this.props.handleRenewLicenseKey}
                            revokeLicenseKey={this.props.revokeLicenseKey}
                            openFeedbackBar={this.openFeedbackBar}
                            getRoles={this.props.getRoles}
                            allRoles={this.props.roles}
                            listMasterAdminsPerLocation={this.props.listMasterAdminsPerLocation}
                            masterAdminsLocation={this.props.masterAdminsLocation}
                        />}



                </Paper>


            </>
        );
    }

}

const mapStateToProps = (state) => ({
    status: statusSelector(state),
    companies: companySelector(state),
    userInfo: userInfoSelector(state),
    roles: rolesSelector(state),
})

const actionCreators = {
    clearStatus,
    createCompany,
    updateCompany,
    listCompanies,
    getRoles,
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, ManageCompanyTable);